import { FormDataModel } from '@/model/FormModel'

export const editFromData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'fee',
        fieldName: '费用',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '下拉选择',
        fieldKey: 'containsRate',
        fieldName: '是否含税',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        option: [{
          id: false,
          name: '否'
        }, {
          id: true,
          name: '是'
        }],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: '',
          pickerType: '',
          filterable: true,
          selectType: 3// 1本地2远程
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'rate',
        fieldName: '税率',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          url: '',
          filterable: false
        }
      }, {
        componentType: 'el-select',
        componentName: '输入框',
        fieldKey: 'invoiceType',
        fieldName: '发票类型',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        option: [],
        config: {
          collapseTags: true,
          isDisabled: false,
          multiple: false,
          clearable: true,
          url: 'dropdown/InvoiceType',
          pickerType: '',
          filterable: true,
          label: 'mark',
          selectType: 2 // 1本地2远程
        }
      }
    ]
  }
]
